import VisibilityTypes from './VisibilityTypes';

export const getSearchVisibilityList = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_VISIBILITY_SEARCH_LIST,
  };
};

export const updateSearchVisibilityList = (payload) => {
  return {
    payload,
    type: VisibilityTypes.UPDATE_VISIBILITY_SEARCH_LIST,
  };
};

export const updateSearchVisibilityListSuccess = (payload) => {
  return {
    payload,
    type: VisibilityTypes.UPDATE_VISIBILITY_SEARCH_LIST_SUCCESS,
  };
};

export const getSearchVisibilityListSuccess = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_VISIBILITY_SEARCH_LIST_SUCCESS,
  };
};

export const getSearchVisibilityListError = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_VISIBILITY_SEARCH_LIST_FAIL,
  };
};

export const getSearchVisibilityListClear = () => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_SEARCH_LIST_CLEAR,
  };
};

export const getSearchVisibilitySetDataList = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_VISIBILITY_SET_SEARCH_LIST_DATA,
  };
};

export const getTrackingStatusDetails = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_TRACKING_STATUS_DETAILS,
  };
};

export const getTrackingStatusDetailsSuccess = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_TRACKING_STATUS_DETAILS_SUCCESS,
  };
};

export const getTrackingStatusDetailsError = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_TRACKING_STATUS_DETAILS_FAIL,
  };
};

export const getVisibilityProductInfo = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_VISIBILITY_PRODUCT_INFO,
  };
};

export const getVisibilityProductInfoSuccess = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_VISIBILITY_PRODUCT_INFO_SUCCESS,
  };
};

export const getVisibilityProductInfoFail = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_VISIBILITY_PRODUCT_INFO_FAIL,
  };
};

export const getShipmentNotesAndDetails = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_SHIPMENT_NOTES_AND_DETAILS,
  };
};

export const getShipmentNotesAndDetailsSuccess = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_SHIPMENT_NOTES_AND_DETAILS_SUCCESS,
  };
};

export const getShipmentNotesAndDetailsFail = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_SHIPMENT_NOTES_AND_DETAILS_FAIL,
  };
};

export const getShipperConsigneeDetails = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_SHIPPER_AND_CONSIGNEE_DETAILS,
  };
};

export const getShipperConsigneeDetailsSuccess = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_SHIPPER_AND_CONSIGNEE_DETAILS_SUCCESS,
  };
};

export const getShipperConsigneeDetailsFail = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_SHIPPER_AND_CONSIGNEE_DETAILS_FAIL,
  };
};

export const updateShipmentTrackingDetails = (payload) => {
  return {
    payload,
    type: VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS,
  };
};

export const updateShipmentTrackingDetailsSuccess = (payload) => {
  return {
    payload,
    type: VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS_SUCCESS,
  };
};

export const updateShipmentTrackingDetailsFail = (payload) => {
  return {
    payload,
    type: VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS_FAIL,
  };
};

export const updateShipmentTrackingDetailsClear = () => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS_CLEAR,
  };
};

export const addNewFileBtn = (payload) => {
  return {
    payload,
    type: VisibilityTypes.ADD_NEW_FILE_ACTION,
  };
};

export const addNewTrackingStatusBtn = (payload) => {
  return {
    payload,
    type: VisibilityTypes.ADD_NEW_TRACKING_STATUS_ACTION,
  };
};

export const editGeneralBtn = (payload) => {
  return {
    payload,
    type: VisibilityTypes.EDIT_GENETRAL_BTN_ACTION,
  };
};

export const editDetailsBtn = (payload) => {
  return {
    payload,
    type: VisibilityTypes.EDIT_DETAILS_BTN_ACTION,
  };
};

export const setSelectedVisibility = (payload) => {
  return {
    payload,
    type: VisibilityTypes.SET_SELECTED_VISIBILITY,
  };
};
export const clearSelectedVisibility = (payload) => {
  return {
    payload,
    type: VisibilityTypes.CLEAR_SELECTED_VISIBILITY,
  };
};

export const getVisibilityExcelData = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_VISIBILITY_EXCEL_DATA,
  };
};

export const getVisibilityExcelDataSuccess = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_VISIBILITY_EXCEL_DATA_SUCCESS,
  };
};

export const getVisibilityExcelDataError = (payload) => {
  return {
    payload,
    type: VisibilityTypes.GET_VISIBILITY_EXCEL_DATA_FAIL,
  };
};

export const sendEmailVisibility = (payload) => {
  return {
    payload,
    type: VisibilityTypes.SENT_EMAIL_VISIBILITY,
  };
};

export const updateRefAndDockNoInProgress = (payload) => {
  return {
    payload,
    type: VisibilityTypes.UPDATE_REF_AND_DOCK_NO,
  };
};

export const updateRefAndDockNoSuccess = (payload) => {
  return {
    payload,
    type: VisibilityTypes.UPDATE_REF_AND_DOCK_NO_SUCCESS,
  };
};

export const updateRefAndDockNoFail = (payload) => {
  return {
    payload,
    type: VisibilityTypes.UPDATE_REF_AND_DOCK_NO_FAIL,
  };
};

export const updateShipmentNoteInProgress = (payload) => {
  return {
    payload,
    type: VisibilityTypes.UPDATE_SHIPMENT_NOTE,
  };
};

export const updateShipmentDetailsInProgress = (payload) => {
  return {
    payload,
    type: VisibilityTypes.UPDATE_SHIPMENT_DETAILS,
  };
};
